import WhatDoYouKnow from 'assets/HealthToolsPrediabetes/what-do-you-know.png';
import WhatIsRisk from 'assets/HealthToolsPrediabetes/what-is-risk.png';
import WhatCanPrevent from 'assets/HealthToolsPrediabetes/what-can-prevent.png';
import WhatAreHealthyFood from 'assets/HealthToolsPrediabetes/what-are-healthy-food.png';
import WhatAreHealthyLifestyle from 'assets/HealthToolsPrediabetes/what-are-healthy-lifestyle.png';
import WhatAreReadyToDo from 'assets/HealthToolsPrediabetes/what-are-ready-to-do.png';

export interface VideoTitle {
  en: string | null;
  es: string | null;
}

export interface PrediabetesVideoData {
  path: string;
  thumb: string;
  title: VideoTitle;
}

export const prediabetesCardsVideosData: PrediabetesVideoData[] = [
  {
    path: '',
    thumb: WhatDoYouKnow,
    title: {
      en: 'What do you already know about prediabetes?',
      es: 'Programa de Prevención de la Diabetes con Vivian Mathias'
    }
  },
  {
    path: '',
    thumb: WhatIsRisk,
    title: {
      en: 'What is your risk of developing diabetes?',
      es: 'Que riesgo tiene de contraer diabetes?'
    }
  },
  {
    path: '',
    thumb: WhatCanPrevent,
    title: {
      en: 'What can you do to prevent diabetes?',
      es: 'Que puede hacer para evitar la diabetes?'
    }
  },
  {
    path: '',
    thumb: WhatAreHealthyFood,
    title: {
      en: 'What are healthy food choices?',
      es: 'Cuales elegir los alimentos saludables?'
    }
  },
  {
    path: '',
    thumb: WhatAreHealthyLifestyle,
    title: {
      en: 'What are some healthy lifestyle changes?',
      es: 'Cuales son algunos cambios saludables en los habitos?'
    }
  },
  {
    path: '',
    thumb: WhatAreReadyToDo,
    title: {
      en: 'What are you ready to do?',
      es: null
    }
  }
];
